<template lang="html">
    <div class="container" id="text-page">
      <!-- <div v-html="row"></div> -->

      <h1 class="mb-3 page-title">Política de envío y devoluciones</h1>
      <p>
        <strong>ANLESA es una plataforma digital que facilita el vínculo entre compradores y vendedores de productos locales y regionales.</strong> Todos los productos disponibles en el marketplace son ofertados y gestionados por vendedores afiliados, quienes asumen plena responsabilidad sobre los términos de entrega, devoluciones y atención postventa.
      </p>

      <br />
      <h5>Envíos</h5>
      <p>
        Los tiempos de entrega, costos, modalidades de envío y zonas de cobertura son determinados por cada vendedor afiliado. Recomendamos revisar cuidadosamente esta información en la ficha de cada producto antes de confirmar su compra.
      </p>

      <br />
      <h5>Devoluciones y cambios</h5>
      <p>
        Cada vendedor define sus propias políticas de devoluciones, cambios y garantías. En caso de requerir alguno de estos procesos, el comprador deberá contactar directamente al vendedor responsable del pedido a través de los canales disponibles en la plataforma.
      </p>

      <br />
      <h5>Responsabilidad de ANLESA</h5>
      <p>
        ANLESA <strong>no participa, intermedia ni asume responsabilidad directa</strong> en los procesos de envío, cumplimiento de pedidos, devoluciones o garantías. La relación comercial se establece directamente entre el comprador y el vendedor.
      </p>

      <br />
      <h5>Recomendación final</h5>
      <p>
        Instamos a todos los usuarios a realizar sus compras de manera informada y responsable, revisando las valoraciones, condiciones del vendedor y políticas aplicables antes de completar cualquier transacción. En caso de detectar irregularidades o comportamientos no éticos por parte de algún vendedor, podrá reportarse mediante los canales de atención de ANLESA para análisis y posible sanción.
      </p>

    </div>
  </template>

  <script>
  export default {
    data(){
      return{
        row:null,
      }
    },

    methods: {
      getData: function(){
        axios.get(tools.url('/api/politica')).then((response)=>{
          this.row = response.data.body;
        }).catch((error)=>{
        })
      },
    },

    mounted(){
        this.getData();
    },
  }
  </script>
